export const I18n = {
	'en': {
		apkUpload: 'APK upload',
		upload: 'Upload',
		cancel: 'Cancel',
		msg_one: 'Are you sure to move it to global market ?',
		msg_two: 'If selected app in a package, it will be delete fom this package.',
		yes: 'Yes',
		no: 'No',
		pack_sure: 'Are you sure to delete a package ?',
		app_sure: 'Are you sure to delete  this app from the package ?',
		app: 'Application',
		pack: 'Package',
		packAttributes: 'Package attributes',
		packManager: 'Package Manager',
		addPackage: 'Add package',
		namePlaceholder: 'Package name',
		save: 'Save',
		companyMarket: 'Company Market',
		searchPlaceholder: 'Search...',
		selectView: 'View selection',
		view_packAndApp: 'Packages with apps',
		view_pack: 'Packages only',
		view_app: 'Apps only',
		view_updates: 'Updates only',
		uploadApk: 'Upload APK',
		appManager: 'Apps manager',
		market: 'Market',
		all: 'All',
		delete: 'Delete',
		updateAll: 'Update all'

	},
	'ru': {
		apkUpload: 'Загрузка АПК',
		upload: 'Загрузить',
		cancel: 'Отмена',
		msg_one: 'Вы хотите перенести в общий маркет ?',
		msg_two: 'Если приложение входит в какой либо пакет, оно будет удалено из него.',
		yes: 'Да',
		no: 'Нет',
		pack_sure: 'Вы действительно хотите удалить пакет?',
		app_sure: 'Вы хотите удалить приложение из пакета ?',
		app: 'Приложение',
		pack: 'Пакет',
		packAttributes: 'Атрибуты пакета',
		packManager: 'Диспетчер пакетов',
		addPackage: 'Добавление Пакета',
		namePlaceholder: 'Имя пакета',
		save: 'Сохранить',
		companyMarket: 'Маркет предприятия',
		searchPlaceholder: 'Поиск...',
		selectView: 'Выбор отображения',
		view_packAndApp: 'Пакеты с приложениями',
		view_pack: 'Только Пакеты',
		view_app: 'Только Приложения',
		view_updates: 'Только Обновления',
		uploadApk: 'Загрузить АPK',
		appManager: 'Диспетчер приложений',
		market: 'Маркет',
		all: 'Все',
		delete: 'Удалить',
		updateAll: 'Обновить все'

	},
	'sk': {
		apkUpload: 'APK nahrať',
		upload: 'Nahrať',
		cancel: 'Zrušiť',
		msg_one: 'Naozaj chcete presunúť na globálnom trhu?',
		msg_two: 'Ak je zvolené aplikácie v balení, bude odstránenie FOM tento balík.',
		yes: 'Áno',
		no: 'žiadny',
		pack_sure: 'Naozaj chcete zmazať balíček?',
		app_sure: 'Naozaj chcete deletethis aplikácie z balíka?',
		app: 'Prihláška',
		pack: 'Balíček',
		packAttributes: 'Atribúty balíček',
		packManager: 'Package manager',
		addPackage: 'Pridať balíček',
		namePlaceholder: 'Názov Packabe ...',
		save: 'Uložiť',
		companyMarket: 'Market Company',
		searchPlaceholder: 'Vyhľadávanie...',
		selectView: 'Voľba View',
		view_packAndApp: 'Balíčky s aplikáciami',
		view_pack: 'Iba balíčky',
		view_app: 'Iba aplikácie',
		view_updates: 'Iba aktualizácie',
		uploadApk: 'nahrať súbor APK',
		appManager: 'Správca aplikácií',
		market: 'Trhové',
		all: 'všetko',
		delete: 'Vymazať',
		updateAll: 'Obnoviť všetko'

	}
};



// WEBPACK FOOTER //
// ./src/I18n/components/companyMarket/index.js